module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "1000px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "color": "#333",
      "margin-top": "100px"
    }
  }, [_vm._v("系统维护中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75434b1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/IndexUpdate.vue
// module id = 1520
// module chunks = 0